module.exports = __webpack_public_path__ + "static/media/sword.73915ebc.png";